import { ConfiguratorScope, PropertyType } from '@brickup/shared/enums'
import {
  FILTER_ALL,
  oneOf,
  selectedKeyFilter,
  stringFilter,
  type ListFilters,
} from '@/components/Internal/DataTable'

/** Whether the catalogue shows every question or only one side of the cut. */
export const PLACEMENT_FILTERS = [FILTER_ALL, 'placed', 'unplaced'] as const
export type PlacementFilter = (typeof PLACEMENT_FILTERS)[number]

export const configuratorListFilters = {
  search: stringFilter(),

  /** Which tree is edited, by its scope and its property type. The defaults
   *  stay out of the address; together they pick a tree rather than narrow
   *  one, so neither is a filter chip. */
  scope: {
    ...oneOf<ConfiguratorScope>(ConfiguratorScope, ConfiguratorScope.CUSTOMER),
    countsAsFilter: false,
    resettable: false,
  },
  propertyType: {
    ...oneOf<PropertyType>(PropertyType, PropertyType.HOUSE),
    countsAsFilter: false,
    resettable: false,
  },

  /** `null` opens the catalogue — every question, wherever it hangs. */
  selected: selectedKeyFilter(),

  /** The catalogue beside the tree has its own two: a tree search that hides
   *  branches would hide the list the operator drags out of. */
  catalogueSearch: stringFilter(),
  placement: oneOf<PlacementFilter>(PLACEMENT_FILTERS, FILTER_ALL),
}

/** The screen's filter state, as the panes beside the tree read it. */
export type ConfiguratorFilters = ListFilters<typeof configuratorListFilters>
